import type { SlotDescriptionsState, SlotRef } from './slot-description-editor';

export type TemplatePublishSourceKind =
  | 'doc'
  | 'app'
  | 'app_block'
  | 'automation'
  | 'workflow'
  | 'step';

export type InitialPublishVisibility = 'workspace' | 'global';

interface BaseTemplatePublishSource {
  workspaceId: string;
  title?: string;
  initialVisibility?: InitialPublishVisibility;
}

export interface DocTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'doc';
  docId: string;
  existingTemplateId?: string;
}

export interface AppTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'app';
  rootDocId: string;
  customAppId?: string;
  existingTemplateId?: string;
}

export interface AppBlockTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'app_block';
  rootDocId: string;
  customAppId: string;
  appBlockId: string;
  existingTemplateId?: string;
}

export interface AutomationTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'automation';
  automationBlockId: string;
  workflowId?: string;
  existingTemplateId?: string;
}

export interface WorkflowTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'workflow';
  workflowId: string;
  existingTemplateId?: string;
}

export interface StepTemplatePublishSource extends BaseTemplatePublishSource {
  kind: 'step';
  workflowId: string;
  stepId: string;
  existingTemplateId?: string;
  inputSlots: readonly SlotRef[];
  configSlots: readonly SlotRef[];
  outputSlots: readonly SlotRef[];
  initialSlotDescriptions?: SlotDescriptionsState;
  stepInsertType?: string;
  isAiStep?: boolean;
}

export type TemplatePublishSource =
  | DocTemplatePublishSource
  | AppTemplatePublishSource
  | AppBlockTemplatePublishSource
  | AutomationTemplatePublishSource
  | WorkflowTemplatePublishSource
  | StepTemplatePublishSource;

export type PublishWizardSource = TemplatePublishSource;

export function getTemplatePublishSourceId(
  source: TemplatePublishSource
): string {
  switch (source.kind) {
    case 'doc':
      return source.docId;
    case 'app':
      return source.rootDocId;
    case 'app_block':
      return source.appBlockId;
    case 'automation':
      return source.automationBlockId;
    case 'workflow':
    case 'step':
      return source.workflowId;
  }
}
